import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, X, Gamepad2 } from 'lucide-react';
import LanguageSelector from './LanguageSelector';

const Header = () => {
  const { t } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-black/80 backdrop-blur-lg border-b border-white/10' 
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <a href="/" className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg gaming-gradient flex items-center justify-center">
              <Gamepad2 className="w-6 h-6 text-white" />
            </div>
            <span className="font-display text-xl md:text-2xl font-bold gaming-gradient-text">
              {t('brand')}
            </span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <a href="#games" className="text-white/70 hover:text-white transition-colors">
              {t('nav.games')}
            </a>
            <a href="#genres" className="text-white/70 hover:text-white transition-colors">
              {t('nav.genres')}
            </a>
            <a href="#support" className="text-white/70 hover:text-white transition-colors">
              {t('nav.support')}
            </a>
          </nav>

          {/* Right side */}
          <div className="flex items-center gap-4">
            <LanguageSelector />
            
            <a 
              href="/s" 
              className="hidden md:inline-flex glow-button px-5 py-2.5 rounded-lg font-semibold text-white"
            >
              {t('nav.startPlaying')}
            </a>

            {/* Mobile menu button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden p-2 text-white"
            >
              {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-black/95 backdrop-blur-lg border-t border-white/10">
          <nav className="flex flex-col p-4 gap-4">
            <a 
              href="#games" 
              className="text-white/70 hover:text-white transition-colors py-2"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {t('nav.games')}
            </a>
            <a 
              href="#genres" 
              className="text-white/70 hover:text-white transition-colors py-2"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {t('nav.genres')}
            </a>
            <a 
              href="#support" 
              className="text-white/70 hover:text-white transition-colors py-2"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {t('nav.support')}
            </a>
            <a 
              href="/s" 
              className="glow-button px-5 py-3 rounded-lg font-semibold text-white text-center"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {t('nav.startPlaying')}
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
